// extracted by mini-css-extract-plugin
module.exports = {"card":"FeedbackCard_card__32CsE","header":"FeedbackCard_header__EIZUk","copy":"FeedbackCard_copy__57vMr","close":"FeedbackCard_close__CmQgN","thumbs":"FeedbackCard_thumbs__cbMOM"};